// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router";
import utils from "./util/index";
import "./assets/iconfont/iconfont.css";
import store from "./store/index";
import * as filters from "./util/filter";
import "@/permission"; // 引入路由守卫
// 全局自动注册过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
import { Popover } from "element-ui";
Vue.use(Popover);
//定义全局变量
Vue.use(ElementUI);
Vue.use(utils.utils);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

//右键菜单
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)
import { parseTime } from './util/filter'
Vue.prototype.parseTime = parseTime

/* eslint-disable no-new */
const vue = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js